import React from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../authConfig"; // Adjust path if necessary

export default function LoginLogoutButtons() {
	const isAuthenticated = useIsAuthenticated();
	const { instance, inProgress } = useMsal();

	const handleLogin = () => {
		if (inProgress === InteractionStatus.None) {
			instance.loginRedirect(loginRequest);
		} else {
			console.warn("Login interaction already in progress");
		}
	};

	const handleLogout = () => {
		if (inProgress === InteractionStatus.None) {
			instance.logoutRedirect();
		} else {
			console.warn("Logout interaction already in progress");
		}
	};

	return (
		<div style={{ padding: "10px 0" }}>
			{isAuthenticated ? (
				<button className="logout-button" onClick={handleLogout}>
					Sign Out
				</button>
			) : (
				<button className="login-button" onClick={handleLogin}>
					Sign In
				</button>
			)}
		</div>
	);
}
